import { CONSTANTS } from '@sohohouse/platform-resources'

export default {
  events: {
    metaTitle: 'META_TITLE_EVENTS_MAIN',
    metaDescription: 'META_DESCRIPTION_EVENTS_MAIN',
    label: 'EXPLORE_EVENTS_LABEL',
    eventTypes: [CONSTANTS.EVENT_TYPES.MEMBER_EVENT]
  },
  screenings: {
    metaTitle: 'META_TITLE_CINEMA_MAIN',
    metaDescription: 'META_DESCRIPTION_FITNESS_MAIN',
    label: 'EXPLORE_CINEMA_LABEL',
    eventTypes: [CONSTANTS.EVENT_TYPES.SCREENING]
  },
  fitness: {
    metaTitle: 'META_TITLE_FITNESS_MAIN',
    metaDescription: 'META_DESCRIPTION_CINEMA_MAIN',
    label: 'EXPLORE_FITNESS_LABEL',
    eventTypes: [CONSTANTS.EVENT_TYPES.HOUSE_RIDE, CONSTANTS.EVENT_TYPES.GYM_CLASS]
  }
}
